import axios from "axios";
import React, { useState, useEffect } from "react";
import decode from "html-entities-decoder";
import { EmployeeLeaves_APIs } from "./EmployeeLeavesAPI";
function PreviewLeaveEmail({ payload, token, togglePreview }) {
	const [previewCode, setPreviewCode] = useState("");
	useEffect(() => {
		axios
			.post(
				`${EmployeeLeaves_APIs.SendEmployeeLeaveDetailsToCustomer}`,
				payload,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((data) => {
				setPreviewCode(decode(data.data.emailContent));
			});
	}, []);
	return (
		<div
			className={`modal-wrapper`}
			tabindex="-1"
			role="dialog"
			style={{ zIndex: "3000" }}
		>
			<div className="modal-dialog modal-xl" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Email Preview</h5>
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={() => {
								togglePreview(false);
							}}
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<div
							dangerouslySetInnerHTML={{ __html: previewCode }}
							className="preview"
						></div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PreviewLeaveEmail;
